import { gql } from '@apollo/client';
export const MessageFragment = gql `
  fragment MessageFragment on DocumentChatMessage {
    id
    content
    role
    status
    type
    feedbackScore
  }
`;
export const ChatFragment = gql `
  fragment ChatFragment on DocumentChat {
    id
    resolved
    resolutionStatus
    messages(orderBy: { createdAt: asc }, limit: 100) {
      ...MessageFragment
    }
  }
  ${MessageFragment}
`;
export const getLastChatQuery = gql `
  query GetLastDocumentChat($documentId: ID!) {
    lastChat: lastDocumentChatOnDocumentByUser(documentId: $documentId) {
      ...ChatFragment
    }
  }
  ${ChatFragment}
`;
